import { useCallback, useMemo } from 'react';
import { InvestmentMemoFormData, FieldPath, SelectedProFormaOption } from '../types';
import { getEmptyRequiredFields } from '../helpers';
import { CARD_REQUIRED_FIELDS, NAV_ITEM_CARDS, InvestmentMemoNavItem } from '../constants';

export const useValidation = (formData: InvestmentMemoFormData, selectedProForma?: SelectedProFormaOption) => {
    const emptyRequiredFields = useMemo(
        () => getEmptyRequiredFields(formData),
        [formData],
    );

    const shouldShowError = useCallback((fieldPath: FieldPath): boolean => (
        !!selectedProForma && emptyRequiredFields.has(fieldPath)
    ), [selectedProForma, emptyRequiredFields]);

    const getFieldError = useCallback((fieldPath: FieldPath): string | null => (
        shouldShowError(fieldPath) ? 'This field is required' : null
    ), [shouldShowError]);

    const hasSectionError = useCallback((cardId: string): boolean => {
        if (!selectedProForma) return false;
        const fields = CARD_REQUIRED_FIELDS[cardId] || [];
        return fields.some(field => emptyRequiredFields.has(field));
    }, [selectedProForma, emptyRequiredFields]);

    const hasNavError = useCallback((navItem: InvestmentMemoNavItem): boolean => {
        if (!selectedProForma) return false;
        const cardIds = NAV_ITEM_CARDS[navItem] || [];
        return cardIds.some(cardId => hasSectionError(cardId));
    }, [selectedProForma, hasSectionError]);

    return {
        shouldShowError,
        getFieldError,
        hasSectionError,
        hasNavError,
    };
};
